import { LAYER } from 'js/components/common/PopupManager/layers';
import { ADD_POPUP } from 'js/components/common/PopupManager/store/actions';
import { TransparentPopup } from './TransparentPopup';

export const showTransparentPopupAction = ({
    id,
    title,
    content,
    onClose,
    closeAll,
    layer = LAYER.COMMON,
    isModal = false,
    articleId,
    ...other
}) => ({
    type: ADD_POPUP,
    payload: {
        id,
        component: TransparentPopup,
        title,
        content,
        onClose,
        closeAll,
        layer,
        isModal,
        articleId,
        ...other
    }
});
